import { TextField, TextFieldProps } from '@mui/material';
import IncFormHelperText from 'components/forms/inc-form-helper-text/inc-form-helper-text.component';
import { Controller, useFormContext } from 'react-hook-form';
import { mergeRefs } from 'util/merge-refs';
import { IncField } from '../fields.types';

export type IncTextFieldProps = IncField<Omit<TextFieldProps, 'variant'>> & {
  onInputChange?: (val) => void;
};

export const IncTextField = ({
  name,
  helperText,
  IncFormHelperTextProps,
  inputRef,
  defaultValue,
  onInputChange,
  ...rest
}: IncTextFieldProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({
        field: { ref: rhfRef, onChange: rhfOnChange, ...fieldRest },
        fieldState: { error },
      }) => (
        <TextField
          onChange={value => {
            onInputChange?.(value);
            rhfOnChange(value);
          }}
          {...fieldRest}
          inputRef={mergeRefs([rhfRef, inputRef])}
          error={!!error}
          helperText={
            <IncFormHelperText
              error={error}
              helperText={helperText}
              {...IncFormHelperTextProps}
            />
          }
          {...rest}
        />
      )}
    />
  );
};

export default IncTextField;
